
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import React, { useEffect } from "react";

import DOMPurify from "isomorphic-dompurify";
import axios from "axios";
import { marked } from "marked";
import { useParams } from "react-router-dom";
import { useState } from "react";

const ChatHistory = () => {
  const { id } = useParams();
  const [name, setName] = useState();
  const [color, setColor] = useState();
  const [headerColor, setHeaderColor] = useState();
  const [sessionList, setSessionList] = useState([]);
  const [messageList, setMessageList] = useState([]);
  const [sessionSelectedId, setSessionSelectedId] = useState();
  const [loadedMessages, setLoadedMessages] = useState(10); // Number of messages currently loaded
  const [totalMessages, setTotalMessages] = useState(0); // Total number of messages available

  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const [messages, setMessage] = useState([]);
  const [daysAgo, setDaysAgo] = useState(10);
  const [isFirst, setIsFirst] = useState(true);
  const today = new Date();
  const calculateDate = new Date();
  calculateDate.setDate(today.getDate() - daysAgo);
  const noHistory = "There is no history yet to show.";

  useEffect(() => {
    if (isFirst) {
      setIsFirst(false);
      if (localStorage.getItem("isRole") === "admin") {
        setDaysAgo(30);
      }
      axios
        .get(`${API_URL}/${API_VERSION}/bot/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setColor(response.data.chatInterface.color);
          setHeaderColor(response.data.chatInterface.headerColor);
          setName(response.data.name);
        })
        .catch((err) => {
          console.log(err);
        });
      axios
        .get(`${API_URL}/${API_VERSION}/bot/chatHistory/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          const msg = response.data.messages.map((msg) => msg);
          setMessage(msg);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    axios
      .get(`${API_URL}/${API_VERSION}/bot/message-session/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setSessionList(response.data);
        if (response.data.length > 0) {
          setSessionSelectedId(response.data[0].session_id);
          fetchSessionData(response.data[0].session_id);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [API_URL, API_VERSION, id, isFirst]);

  useEffect(() => {
    // When messages are fetched, update the total number of messages available
    setTotalMessages(messageList.length);
  }, [messageList]);

  const fetchSessionData = (selectedId) => {
    axios
      .get(`${API_URL}/${API_VERSION}/bot/session-msg/${id}/${selectedId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const msg = response.data[0].messages.map((msg) => msg);
        setMessageList(msg);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlerChange = (event) => {
    const selectedId = event.target.value;
    setSessionSelectedId(selectedId);
    fetchSessionData(selectedId);
  };

  const loadMoreMessages = () => {
    setLoadedMessages((prevCount) => prevCount + 10); // Increment the number of loaded messages by 10
   // setMessageList((prevMessages) => prevMessages);
  };

  const formatMessageDate = (timestamp) => {
    const messageDate = new Date(timestamp);
    return messageDate.toLocaleString();
  };

  // Determine if there are more messages to load
  const hasMoreMessages = totalMessages > loadedMessages;
  const startIndex = Math.max(totalMessages - loadedMessages, 0);

  // Slice the messageList array to get the messages to display
  const messagesToShow = messageList.slice(startIndex);
  // Calculate the number of messages to display
 // const messagesToShow = messageList.slice(0, loadedMessages);

  

  return (
    <>
      <section className="chating_box">
        <Container>
          <Row className="justify-content-center mt-3">
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Select Session ID</Form.Label>
                <Form.Select
                  type="text"
                  value={sessionSelectedId}
                  onChange={handlerChange}
                >
                  {sessionList.map((id) => (
                    <option value={id.session_id} key={id.session_id}>
                      {id.session_id} - {" "}
                      {new Date(id.createdAt).toLocaleString()}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={12}>
              <div className="chatingwrap">
                <div
                  className="chating_head"
                  style={{ background: headerColor }}
                >
                  <div className="brand">
                    <span>{name}</span>
                  </div>
                  <div className="refresh">
                    <i className="fa-solid fa-rotate"></i>
                  </div>
                </div>

                <div className="chating_area">
                  {hasMoreMessages && (
                    <div className="text-center mt-3">
                      <button className="load_btn" style={{ background: headerColor }} onClick={loadMoreMessages}>Load More</button>
                    </div>
                  )}
                  {messages.length === 0 ? (
                    <ul>
                      <li className="sender">
                        <div className="cont">
                          <span>{noHistory}</span>
                        </div>
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                  {messagesToShow.map((msg, index) => {
                    if (msg.data !== null) {
                      return (
                        <ul key={msg.id}>
                          <li
                            className={
                              msg.from === "user" ? "repaly" : "sender"
                            }
                            style={
                              msg.from === "user"
                                ? { background: color }
                                : {}
                            }
                          >
                            <div className="cont">
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(
                                    marked.parse(msg.data.text)
                                  ),
                                }}
                              ></span>
                            </div>
                          </li>
                        </ul>
                      );
                    } else {
                      return null;
                    }
                  })}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChatHistory;

